/* assets/press-hits-marquee.js
 * Press Hits - Marquee (mobile-hardened)
 * - 无缝匀速从右往左
 * - Pointer/Touch 双栈拖拽
 * - 等尺寸就绪后再测量；页面恢复/横竖屏变化自愈
 * - rAF 被节流时自动切换 CSS 动画兜底
 */
(function () {
  function once(el) { el.setAttribute('data-marquee-initialized','1'); }
  function inited(el){ return el.getAttribute('data-marquee-initialized') === '1'; }

  function getGapPx(track){
    const cs = getComputedStyle(track);
    return parseFloat(cs.columnGap || cs.gap) || 0;
  }

  function measureLoop(track, count){
    const prev = track.style.transform;
    track.style.transform = 'none';
    const gap = getGapPx(track);
    // 若图片宽度尚未可测，返回 0 触发重试
    let loopWidth = 0;
    for (let i = 0; i < count; i++){
      const el = track.children[i];
      const w = el.getBoundingClientRect().width;
      if (!w) { loopWidth = 0; break; }
      loopWidth += w;
      if (i > 0) loopWidth += gap;
    }
    if (loopWidth) loopWidth += gap; // 组尾与下一组首的衔接 gap
    track.style.transform = prev;
    return { loopWidth, gap };
  }

  // —— CSS 动画兜底 —— //
  function startCssFallback(root, viewport, track, baseSpeed, count){
    // 再测一次，确保有数
    const m = measureLoop(track, count);
    if (!m.loopWidth) return false;
    const loopW = m.loopWidth;
    const duration = loopW / baseSpeed; // s
    // 注入局部样式（仅作用于当前 section）
    const styleId = `ph-style-${root.id}`;
    if (!document.getElementById(styleId)) {
      const st = document.createElement('style');
      st.id = styleId;
      st.textContent = `
#${root.id} .press-hits__track{animation: phMarquee-${root.id} ${duration}s linear infinite;}
#${root.id}.is-paused .press-hits__track{animation-play-state: paused;}
@keyframes phMarquee-${root.id}{
  from{transform:translate3d(0,0,0)}
  to  {transform:translate3d(${-loopW}px,0,0)}
}`;
      document.head.appendChild(st);
    } else {
      // 如果之前注入过样式（比如速度变了），直接更新时长
      const sheet = document.getElementById(styleId).sheet;
      for (let i=0;i<sheet.cssRules.length;i++){
        const r = sheet.cssRules[i];
        if (r.type === CSSRule.STYLE_RULE && r.selectorText === `#${root.id} .press-hits__track`) {
          r.style.animation = `phMarquee-${root.id} ${duration}s linear infinite`;
        }
      }
    }
    // 拖拽时暂停动画，松手恢复（用最简单的方式保证可靠）
    const pause = ()=> root.classList.add('is-paused');
    const resume = ()=> root.classList.remove('is-paused');
    // Pointer + Touch
    const hasPointer = window.PointerEvent !== undefined;
    if (hasPointer){
      viewport.addEventListener('pointerdown', pause);
      viewport.addEventListener('pointerup', resume);
      viewport.addEventListener('pointercancel', resume);
      viewport.addEventListener('pointerleave', resume);
    } else {
      viewport.addEventListener('touchstart', pause, {passive:true});
      ['touchend','touchcancel'].forEach(ev=>viewport.addEventListener(ev, resume, {passive:true}));
    }
    
    return true;
  }

  function initOne(root){
    if (!root || inited(root)) return;
    const viewport = root.querySelector('.press-hits__viewport');
    const track    = root.querySelector('.press-hits__track');
    if (!viewport || !track) return;
    // 禁止原生拖拽（防止出现“拖出页面的半透明缩略图”）
    viewport.querySelectorAll('img, a').forEach(el=>{
    el.setAttribute('draggable','false');
    el.addEventListener('dragstart', e => e.preventDefault());
    });

    const baseSpeed = parseFloat(viewport.dataset.speed || '60'); // px/s
    const pauseOnHover = false; // 永远不因鼠标悬停而暂停


    // 原始节点数量
    const originals = Array.from(track.children);
    const count = originals.length;
    if (!count) return;

    // [原始|克隆]
    const frag = document.createDocumentFragment();
    originals.forEach(n => frag.appendChild(n.cloneNode(true)));
    track.appendChild(frag);

    let loopWidth = 0, gap = 0;
    let phase = 0, lastTs = 0;
    let dragging = false, dragStartX = 0, phaseAtDragStart = 0;
    let paused = false;
    let progressed = false; // 看门狗：确认动画在前台真实推进
    let rafId = 0;

    function render(){
      const offset = ((phase % loopWidth) + loopWidth) % loopWidth;
      const tx = -offset;
      track.style.transform = `translate3d(${tx}px,0,0)`;
      progressed = true;
    }

    function tick(ts){
      if (!lastTs) lastTs = ts;
      const dt = (ts - lastTs) / 1000;
      lastTs = ts;
      if (!paused && !dragging){
        phase += baseSpeed * dt; // 从右向左
        render();
      }
      rafId = requestAnimationFrame(tick);
    }

    // 交互
    if (pauseOnHover){
      root.addEventListener('mouseenter', ()=> paused = true);
      root.addEventListener('mouseleave', ()=> paused = false);
    }
    const hasPointer = window.PointerEvent !== undefined;

    if (hasPointer){
      viewport.addEventListener('pointerdown', (e)=>{
        dragging = true; paused = true;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
        dragStartX = e.clientX;
        phaseAtDragStart = phase;
      });
      viewport.addEventListener('pointermove', (e)=>{
        if (!dragging) return;
        const dx = e.clientX - dragStartX;
        phase = phaseAtDragStart - dx; // 右拖 -> 视觉右移
        render();
      });
      const endDrag = ()=>{
        if (!dragging) return;
        dragging = false;
        viewport.classList.remove('is-dragging');
        setTimeout(()=> paused = false, 300);
      };
      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', endDrag);
    } else {
      // Touch 栈（旧 iOS Safari）
      let touchStartX = 0;
      viewport.addEventListener('touchstart', (e)=>{
        const t = e.touches && e.touches[0];
        dragging = true; paused = true;
        touchStartX = t ? t.clientX : 0;
        phaseAtDragStart = phase;
      }, {passive:true});
      viewport.addEventListener('touchmove', (e)=>{
        if (!dragging) return;
        const t = e.touches && e.touches[0];
        if (!t) return;
        const dx = t.clientX - touchStartX;
        phase = phaseAtDragStart - dx;
        render();
      }, {passive:true});
      const endTouch = ()=>{
        if (!dragging) return;
        dragging = false;
        setTimeout(()=> paused = false, 300);
      };
      viewport.addEventListener('touchend', endTouch, {passive:true});
      viewport.addEventListener('touchcancel', endTouch, {passive:true});
    }


    // 尺寸/方向/恢复
    function onResize(){
      const progress = loopWidth ? ((phase % loopWidth) + loopWidth) % loopWidth : 0;
      const m = measureLoop(track, count);
      loopWidth = m.loopWidth; gap = m.gap;
      if (!loopWidth) return; // 宽度未就绪，等待下次
      phase = progress;
      render();
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    window.addEventListener('pageshow', (e)=>{ if (e.persisted) { lastTs = 0; progressed=false; }});

    // 启动：反复测量直到拿到有效宽度
    function tryStartWithMeasure(attempt=0){
      const m = measureLoop(track, count);
      if (!m.loopWidth){
        if (attempt < 30){ // 最多重试 ~3s（每100ms）
          return setTimeout(()=>tryStartWithMeasure(attempt+1), 100);
        } else {
          // 彻底测不到宽，直接切 CSS 兜底
          startCssFallback(root, viewport, track, baseSpeed, count);
          return;
        }
      }
      loopWidth = m.loopWidth; gap = m.gap;
      render();
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);

      // 看门狗：1.2s 后如果仍未推进，切 CSS 兜底
      setTimeout(()=>{
        if (!progressed){
          cancelAnimationFrame(rafId);
          startCssFallback(root, viewport, track, baseSpeed, count);
        }
      }, 1200);
    }

    // 图片就绪或兜底后启动
    const imgs = track.querySelectorAll('img');
    let pending = imgs.length;
    if (pending === 0){
      tryStartWithMeasure();
    } else {
      imgs.forEach(img=>{
        if (img.complete) { if (--pending === 0) tryStartWithMeasure(); }
        else img.addEventListener('load', ()=>{ if (--pending === 0) tryStartWithMeasure(); }, {once:true});
      });
      // 兜底：3s 后强制尝试
      setTimeout(()=>{ if (pending > 0) tryStartWithMeasure(); }, 3000);
    }

    once(root);
  }

  function initAll(ctx){
    (ctx || document).querySelectorAll('section[id^="press-hits-"]').forEach(initOne);
  }

  // 普通页面
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=> initAll());
  } else {
    initAll();
  }
  // 主题编辑器插入/更新
  document.addEventListener('shopify:section:load', (e)=>{
    const el = e && e.detail && e.detail.sectionId
      ? document.getElementById(`press-hits-${e.detail.sectionId}`) || e.target
      : e.target;
    initAll(el || document);
  });
})();
